import React from "react";
import CoinImage from "../../assets/images/coin.png";

const InputComponent = ({
  label,
  type,
  name,
  placeholder,
  value,
  required,
  handleChange,
  icon,
  disabled
}) => {
  return (
    <>
      <div className="m-2">
        <label
          className="block mb-2 text-sm font-medium text-white"
        >
          {label}
        </label>
        <div className="relative w-full">
          <input
            type={type}
            placeholder={placeholder}
            value={value}
            name={name}
            required={required}
            onChange={handleChange}
            disabled={disabled}
            aria-describedby="helper-text-explanation"
            className="bg-202531 border-0 border-transparent text-white text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 pr-10"
          />
          {
            icon && <img src={CoinImage} className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 cursor-pointer" />
          }
        </div>
      </div>
    </>
  );
};

export default InputComponent;